import { cloneElement } from 'react';

import {
  Button,
  Dialog,
  HexIcon,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

type Props = {
  name: string;
  orgId: string;
  isChild: boolean;
  destroy: () => void;
  setOrganizationOptions?: { skipRedirect?: boolean };
};

export const CreatedOrganizationDialog = ({
  name,
  orgId,
  isChild,
  destroy,
  setOrganizationOptions,
}: Props) => {
  const { setCurrentOrganization } = useOrganizations();
  const iconSize = 96;
  const iconEl = cloneElement(<HexIcon variant="success" />, {
    size: iconSize,
  });

  const handleClose = () => {
    setCurrentOrganization(orgId, setOrganizationOptions);
    destroy();
  };

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      PaperProps={{ sx: { overflow: 'visible' } }}
      testId="created-organization-dialog"
    >
      <Stack alignItems="center" pt={48} pb={24} px={24}>
        <Stack sx={{ mt: -iconSize / 2 }}>{iconEl}</Stack>
        <Typography
          variant="h4"
          mt={24}
          textAlign="center"
          color={tokens.theme.fg.structural.primary}
        >
          {`${name} ${isChild ? 'child ' : ''}organization created!`}
        </Typography>
        <Typography
          variant="P14R"
          color={tokens.theme.fg.structural.secondary}
          mt={8}
          textAlign="center"
        >
          Go ahead and invite your team to your new organization.
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="center" pb={24} px={24}>
        <Button onClick={handleClose} data-testid="created-organization-close">
          Close
        </Button>
      </Stack>
    </Dialog>
  );
};
